import { useState, useEffect, useRef } from "react"
import { fetchLeadStatuses } from "src/features/pipelines/api/pipelinesApi"

let cachedStatuses = null

export function useLeadStatuses() {
  const [statuses, setStatuses] = useState(cachedStatuses || [])
  const [loading, setLoading] = useState(!cachedStatuses)
  const abortRef = useRef(null)

  useEffect(() => {
    if (cachedStatuses) return

    abortRef.current?.abort()
    const ctrl = new AbortController()
    abortRef.current = ctrl

    setLoading(true)
    fetchLeadStatuses()
      .then((data) => {
        if (!ctrl.signal.aborted) {
          cachedStatuses = data.statuses || []
          setStatuses(cachedStatuses)
        }
      })
      .catch(() => {})
      .finally(() => {
        if (!ctrl.signal.aborted) setLoading(false)
      })

    return () => ctrl.abort()
  }, [])

  return { statuses, loading }
}

export function invalidateLeadStatuses() {
  cachedStatuses = null
}
